// Deep links into the QuickBooks Online web UI — opens whatever company the
// signed-in Intuit user currently has active there (no realm needed in the
// URL itself). Separate from the API host (qbo.py's api_base()): the web UI
// and REST API live on different domains for the same environment.
const QBO_WEB_HOSTS = {
  sandbox: "https://sandbox.qbo.intuit.com",
  production: "https://qbo.intuit.com",
};

// QBO entity type -> the web UI's transaction-detail route.
const QBO_TXN_PATHS = {
  Bill: "bill",
  Purchase: "expense",
  BillPayment: "billpaymentcheck",
  VendorCredit: "vendorcredit",
};

/** Direct link to one synced transaction, or null if there's nothing to link to yet. */
export function qboTransactionLink(environment, qboType, qboId) {
  if (!qboId) return null;
  const host = QBO_WEB_HOSTS[environment] || QBO_WEB_HOSTS.sandbox;
  const path = QBO_TXN_PATHS[qboType] || "bill";
  return `${host}/app/${path}?txnId=${encodeURIComponent(qboId)}`;
}

/** Link to the connected company's QuickBooks homepage — no specific transaction. */
export function qboHomeLink(environment) {
  return `${QBO_WEB_HOSTS[environment] || QBO_WEB_HOSTS.sandbox}/app/homepage`;
}
